<template>
  <section class="hero">
    <figure class="hero__figure" data-parallax="-0.3">
      <img :src="switchImg" :alt="hero.alt">
      <!-- <div class="hero__image" :style="`backgroundImage: url('${switchImg}')`"></div> -->
    </figure>

    <div class="hero__wrapper">
      <h2 class="hero__title">
        {{ hero.title }}
      </h2>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import gsap from 'gsap';

import PIXIRender from '@/assets/lib/video/pixirenderer';

require('intersection-observer');

export default {
  name: 'Hero',

  props: ['heroEntered'],

  data() {
    return {
      canvas: null,
      hero: {},
      firstAnim: true,
    };
  },

  computed: {
    ...mapGetters(['getDataCityComponent']),

    switchImg() {
      if ((window.chrome && window.chrome.webstore) || (window.opr && window.opr.addons)) {
        return `${this.hero.url}.webp`;
      }
      return `${this.hero.url}.jpg`;
    },
  },

  created() {
    this.hero = this.getDataCityComponent(this.$route.params.city, 'hero');

    this.canvas = document.createElement('canvas');
    this.canvas.id = 'video-canvas';
    this.canvas.style.position = 'absolute';
    // this.canvas.style.zIndex = '1';
  },

  mounted() {
    this.enterAnimation(this.heroEntered);

    const img = this.obtainImg();

    new Promise((resolve) => {
      this.PIXIRenderers = new PIXIRender(this.canvas, img, resolve);
    }).then(() => {
      this.animateInCnv();
    });
  },

  methods: {
    enterAnimation(callback) {
      const title = this.$el.querySelector('.hero__title');
      const img = this.$el.querySelector('.hero__figure');

      gsap.set(img, { opacity: 0 });

      gsap.set(title, {
        yPercent: 0,
        xPercent: -50,
        rotation: 0,
        skewY: 5,
        autoAlpha: 0,
        transformOrigin: '0 0',
      });

      gsap.to(img, 0.5, { opacity: 1, delay: 0.7 });

      setTimeout(() => {
        callback();
      }, 1800);

      gsap.to(title, 1, {
        yPercent: -50,
        skewY: 0,
        rotation: '-6deg',
        autoAlpha: 1,
        delay: 1,
        ease: gsap.Expo.easeOut,
      });
    },

    injectCanvas(index, canvas) {
      const cont = this.$el.querySelector('.hero__figure');
      cont.appendChild(canvas);
    },

    animateInCnv() {
      this.PIXIRenderers.setTexture(0);

      this.injectCanvas(1, this.canvas);

      this.intersectionObserver = new IntersectionObserver((entries) => {
        if (entries[0].intersectionRatio <= 0) {
          this.PIXIRenderers.stop();
        } else {
          const timing = this.firstAnim ? 2 : 0.1;
          this.PIXIRenderers.phaseIn(timing, true);
          this.firstAnim = false;
        }
      });

      this.intersectionObserver.observe(this.$el);
    },

    obtainImg() {
      if ((window.chrome && window.chrome.webstore) || (window.opr && window.opr.addons)) {
        return `${this.hero.url}.webp`;
      }
      return `${this.hero.url}.jpg`;
    },
  },

  beforeDestroy() {
    this.PIXIRenderers.destroy();
    this.intersectionObserver.unobserve(this.$el);
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/colors';
@import '../styles/mixins';
@import '../application';

.hero {
  position: relative;
  width: 100%;
  height: 110vh;
  overflow: hidden;
  -webkit-mask: linear-gradient(to top,rgba(0,0,0,.1) 0,rgba(0,0,0,.5) 50px,#000 100px);

  &__figure {
    position: relative;
    height: 100%;
    margin: 0;
    padding: 0;

    &::after {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;

      background: $color-black;
      opacity: 0.2;
    }
  }

  &__image {
    position: absolute;
    width: 100%;
    height: 100%;

    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
  }

  img {
    width: 100%;
    @include visually-hidden;
  }

  h2 {
    font-size: 3.25rem;
    color: $color-blue;

    z-index: 10;
    backface-visibility: hidden;

    @include mq(sm) {
      font-size: 4.25rem;
    }

    @include mq(md) {
      font-size: 6.875rem;
    }
  }

  .hero__wrapper {
    position: absolute;
    top: calc(50% - 80px);
    left: 50%;
    perspective: 1000px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Hero.vue